module.exports = __webpack_public_path__ + "static/media/TN-Men-Bags.3a0e0dd2.svg";